import { render, staticRenderFns } from "./TopicLive.vue?vue&type=template&id=248c2002&scoped=true"
import script from "./TopicLive.vue?vue&type=script&lang=js"
export * from "./TopicLive.vue?vue&type=script&lang=js"
import style0 from "./TopicLive.vue?vue&type=style&index=0&id=248c2002&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248c2002",
  null
  
)

export default component.exports